// extracted by mini-css-extract-plugin
module.exports = {"root":"HotelSearchBox_root__dLDzt","closeButton":"HotelSearchBox_closeButton___2HAX"};